<template>
	<div style="margin-top:20px;" class="top-line">
		<b-modal v-model="paymentTypeModel.show" size="sm" title="选择支付方式">
			<b-row align-v="center">
				<b-col lg="12">
					<b-form-group>
						<b-form-radio v-model="paymentTypeModel.selectedType" name="paymentType" value="fund">
							余额支付(余额:￥{{paymentTypeModel.memberFund}})</b-form-radio>
					 </b-form-group>
				</b-col>
			</b-row>
			<template slot="modal-footer">
				<b-button size="sm" variant="success" @click="submitSalesPayment()">支付</b-button>
				<b-button size="sm" variant="danger" @click="paymentTypeModel.show = false">取消</b-button>
			</template>
		</b-modal>
		<b-modal id="payDeposteModel" v-model="payDeposteModel.show" title="会员付款">
			<b-row align-v="center">
				<b-col lg="12" class="registerInfo">
					<b-form>
						<b-form-group label="绑定定单:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.preSaleOrderRecordCode" size="sm" readonly>
							</b-form-input>
						</b-form-group>
					</b-form>
					<b-form>
						<b-form-group label="总金额:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.preSaleOrderRecordTotalOrderCost" size="sm" readonly>
							</b-form-input>
						</b-form-group>
					</b-form>
					<b-form>
						<b-form-group label="已支付定金:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.depositBillRecordDepositPaymentSum" size="sm"
								readonly></b-form-input>
						</b-form-group>
					</b-form>
					<!-- <b-form>
						<b-form-group label="折扣:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.discount" size="sm"
								readonly></b-form-input>
						</b-form-group>
					</b-form> -->
					<b-form>
						<b-form-group label="需支付余额:" label-cols-lg="3" label-align-lg="right" label-size="sm">
							<b-form-input v-model="payDeposteModel.remainSum" type="number" size="sm"></b-form-input>
						</b-form-group>
					</b-form>
				</b-col>
			</b-row>
			<template slot="modal-footer">
				<b-button size="sm" variant="success" @click="submitBookingOrderDeposite()">
					确认支付
				</b-button>
				<b-button size="sm" variant="danger" @click="payDeposteModel.show = false">
					取消
				</b-button>
			</template>
		</b-modal>
		<div class="d-flex search-wrap">
			<div class="d-flex">
				<b-input-group style="width:220px;margin-right:10px;">
					<b-form-input size="sm" autocomplete="off" v-model="depositBillRecordCode" placeholder="输入查询待支付定单号" class="order-input"></b-form-input>
				</b-input-group>

				<DatePicker type="daterange" v-model="selectDates" transfer placement="bottom-end" placeholder="选择待支付定单定单时间"
					style="width: 200px;" @on-change="onDateChange" class="search-input"></DatePicker>
				<b-input-group style="width:220px;margin-right:10px;">
					<b-form-input size="sm" autocomplete="off" v-model="operatorName" placeholder="输入经办人账号或姓名" class="order-input"></b-form-input>
				</b-input-group>
				<b-button size="sm" v-on:click="onSearch()" variant="success" class="order-button">查询</b-button>
				<b-button style="margin-left: 20px;" size="sm" v-on:click="clearSearch()" variant="success" class="order-button">重置</b-button>
				<!-- <b-input-group style="width:220px; margin-left:10px;">
					<b-form-select
						  v-model="operatorType"
						  style="height: 32px; padding: 0 0 0 2px;"
					      class="mb-2 mr-sm-2 mb-sm-0"
					      :options="{ 'F': '客户本人', 'B': '苗场', 'G': '客户经理' }"
					      id="inline-form-custom-select-pref"
					    >
						<template v-slot:first>
						    <option :value="null">请选择经办人</option>
						    </template>
						</b-form-select>

				</b-input-group>	 -->
			</div>
		</div>
		<div class="delivery-list">
			<b-table id="deposit-table" :fields="depositBillList.fields" :items="depositBillList.depositBillMainVOList" small bordered
				hover show-empty empty-text="没有找到匹配的记录" :busy="depositBillList.isTableBusy" caption-top>
				<template slot="table-caption">
					<!-- <span>苗定单列表</span> -->
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
				<template v-slot:cell(depositBillListAction)="row">
					<b-link
						:to="{path: '/member/no-deposit-detail', query: { depositBillRecordUuid: row.item.depositBillRecordUuid }}"
						target="_blank">查看</b-link>
                   <span>
                        /
                        <a href="#" v-on:click="onSginContract(row)">下载种苗定购协议</a>
                    </span>
					/<a  href="javascript:void(0);" @click="closeDeposit(row.item.depositBillRecordUuid)" style="color:#00B151;">关闭</a>
					<!-- <span>
					     /
					     <a href="#" v-on:click="onCancel(row)">取消</a>
					 </span> -->
					<!-- <span v-if="row.item.paidStatus=='定金已支付'">
						/
						<a href="#" v-on:click="onPayOrder(row)">支付余额</a>
					</span> -->
				</template>
				<template v-slot:cell(depositBillRecordDepositPaymentSum)="row">
					<span>{{getNumberThousandString(row.item.depositBillRecordDepositPaymentSum,'0.00')}}</span>
				</template>
				<template v-slot:cell(surplus)="row">
					<span>{{getNumberThousandString(row.item.surplus,'0.00')}}</span>
				</template>
				<template v-slot:cell(totalFee)="row">
					<span>{{getNumberThousandString(row.item.totalFee,'0.00')}}</span>
				</template>
				<template v-slot:cell(depositBillRecordCreateAt)="row">
					<span>{{formatDateTimeString(row.item.depositBillRecordCreateAt)}}</span>
				</template>
				<!-- 待付余额 -->
				<!-- <template v-slot:cell(remainingSum)="row">
					<span>{{row.item.mainTotalMoney-row.item.depositBillRecordDepositPaymentSum}}</span>
				</template> -->
			</b-table>
			<div class="pageControl">
			    <b-pagination v-model="depositBillList.feSearch.limit.conditions.pageStart"
			        style="margin-top:20px;"
					:total-rows="depositBillList.feSearch.limit.conditions.total"
			        :per-page="depositBillList.feSearch.limit.conditions.pageLength"
			        align="center"
			        size="sm"
			        ellipsis-text="..."
			        first-text="首页"
			        prev-text="上一页"
			        next-text="下一页"
			        last-text="尾页"
			        limit="10"
			        @change="onDepositPageChange"></b-pagination>
			</div>
		</div>

		<PayModal ref="payModal" />
	</div>
</template>

<script>
	import api from "@/api/api";
	import {
		formatDateTimeString,
		getNumberThousandString,
		numberToFixed
	} from "@/libs/utils";
	import search from '@/libs/search';
	import "@/style/global.css";
	import PayModal from '../member/pay';
import { param } from "jquery";
	export default {
		name: "OrderList",
		components: {
			PayModal
		},
		data() {
			return {
				api,
				selectDates: [],
				depositBillRecordCode:'',
				operatorName:'',
				operatorType:'',
				depositBillList: {
					fields: [{
							key: "depositBillRecordCode",
							label: "待支付定单编号"
						},
						{
							key: "seedFarmName",
							label: "苗场名称"
						},
						{
							key: "weekSeq",
							label: "周次"
						},
						{
							key: "sendProductDate",
							label: "发货日期"
						},
						{
							key: "receiptFullAddress",
							label: "收货地址"
						},
						{
							key: "depositBillRecordDepositPaymentSum",
							label: "待支付定金"
						},
						{
							key: "surplus",
							label: "待付余额"
						},
						{
							key: "totalFee",
							label: "产品总额"
						},
						{
							key: "paidStatus",
							label: "状态"
						},
						{
							key: "depositBillRecordCreateAt",
							label: "下单时间",
							render: (h, params) => formatDateTimeString(h, params.row.depositBillRecordCreateAt)
						},
						{
							key: "operatorName",
							label: "经办人"
						},
						{
							key: "depositBillListAction",
							label: "操作"
						}
					],
					keyword: '',
					depositBillMainVOList: [],
					isTableBusy: false,
					feSearch: search.getSearchParams()
				},
                paymentTypeModel: {
                    show: false,
                    depositValue: 0,
                    selectedType: "fund",
                    memberFund: 0
                },
				payDeposteModel: {
					show: false,
					preSaleOrderRecordUuid: '',
					preSaleOrderRecordCode: '',
					preSaleOrderRecordTotalOrderCost: '',
					depositBillRecordDepositPaymentSum: '',
					remainSum: '',
					discount:''
				},
                depositBillRecordUuidArray: []
			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: 'MemberLogin'
				});
				return;
			};
			this.depositBillList.feSearch.filters.enable = false;
			this.depositBillList.feSearch.filters.conditions = [];
			this.getUserDepositBillInfoList();
			this.getMemberBalance();
		},
		methods: {
			formatDateTimeString,
			getNumberThousandString,
			numberToFixed,
			getMemberBalance() {
				api.webGetMemberUserDetail({
					userUuid: this.getLoginCookieUuid()
				}).then(res => {
					if (res.code === 0) {
						this.paymentTypeModel.memberFund = res.data.memberFund;
					}
				});
			},
			onDateChange(e) {
				this.selectDates = e;
				let field = "depositBillRecordCreateAt";
				search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field);
				search.globalResetSearch(this.depositBillList.feSearch);
				this.depositBillList.feSearch.filters.enable = true;
				this.depositBillList.feSearch.filters.conditions.push({
				    name: field,
				    type: 'datebetween',
				    value: JSON.stringify(e)
				});
				this.getUserDepositBillInfoList();
			},
			onSearch() {
				if(this.depositBillRecordCode){
					let field = "depositBillRecordCode";
					search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field);
					search.globalResetSearch(this.depositBillList.feSearch);
					this.depositBillList.feSearch.filters.enable = true;
					this.depositBillList.feSearch.filters.conditions.push({
						name: field,
						type: 'like',
						value: this.depositBillRecordCode
					});
				}
				if(this.operatorName){
					let field = 'concat(uers.userPersonName, uers.userName)';
					search.globalRemoveFilterConditionKey(this.depositBillList.feSearch, field);
					search.globalResetSearch(this.depositBillList.feSearch);
					this.depositBillList.feSearch.filters.enable = true;
					this.depositBillList.feSearch.filters.conditions.push({
						name: field,
						type: 'like',
						value: this.operatorName
					});
				}
				this.getUserDepositBillInfoList();
			},
			clearSearch(){
				this.selectDates=[];
				this.depositBillRecordCode='';
				this.operatorName='';
				this.depositBillList.feSearch.filters.enable = false;
				this.depositBillList.feSearch.filters.conditions = [];
				this.getUserDepositBillInfoList();
			},
			getUserDepositBillInfoList() {
				//获取定金待支付的列表
				this.depositBillList.isTableBusy = true;
				api.webGetNoPaidDepositBillOrderList  (this.depositBillList.feSearch).then(res => {
					// uni.hideLoading();
					this.depositBillList.isTableBusy = false;
					if (res.code === 0) {
						if (res.data.depositBillMainVOList.length > 0) {
							this.depositBillList.depositBillMainVOList = res.data.depositBillMainVOList;
							this.depositBillList.depositBillMainVOList.forEach(e => {
								if(e.depositBillRecordOrderStatus=="关闭"){
								       e.depositBillRecordPaidStatus="关闭";
								}
								e.depositBillRecordDepositPaymentSum=this.numberToFixed(e.depositBillRecordDepositPaymentSum,2);
								e.surplus=this.numberToFixed(e.totalFee-e.depositBillRecordDepositPaymentSum,2)
								e.totalFee=this.numberToFixed(e.totalFee,2);
							});
							// 获取分页条数
							search.globalSetFilterRecordCount(this.depositBillList.feSearch, res.data.filterRecordCount);
						}
						else{
							this.depositBillList.depositBillMainVOList =[];
						}
					}
				});
			},
			onDepositPageChange(pageNum) {
				search.globalPageOnChange(this.depositBillList.feSearch, pageNum);
				this.getUserDepositBillInfoList();
			},
			onPayOrder(row) {
				this.$bvModal
					.msgBoxConfirm("是否确认支付该定单？", {
						size: "sm",
						buttonSize: "sm",
						okVariant: "danger",
						okTitle: "是",
						cancelTitle: "否"
					})
					.then(value => {
						if (value) {
							this.payDeposteModel.preSaleOrderRecordUuid = row.item.depositBillRecordUuid;
							this.payDeposteModel.preSaleOrderRecordCode = row.item.depositBillRecordCode;
							this.payDeposteModel.preSaleOrderRecordTotalOrderCost = row.item.totalFee;
							this.payDeposteModel.depositBillRecordDepositPaymentSum = row.item.depositBillRecordDepositPaymentSum;
							this.payDeposteModel.discount=(row.item.mainTotalMoney*1000+row.item.packageFee*1000+row.item.deliveryFee*1000-row.item.totalFee*1000)/1000;
							// this.payDeposteModel.remainSum = row.item.mainTotalMoney-row.item.depositBillRecordDepositPaymentSum;
							this.payDeposteModel.remainSum = ((row.item.totalFee *1000)-(row.item.depositBillRecordDepositPaymentSum * 1000))/1000;
							this.payDeposteModel.show = true;
						}
					});
			},
			submitBookingOrderDeposite() {
                this.depositBillRecordUuidArray.push(this.payDeposteModel.preSaleOrderRecordUuid);
				api.webPreSaleDepositPayWithFund({depositBillRecordUuidArray:this.depositBillRecordUuidArray,orderType:'REMAININGMONEY'}).then(res => {
					if (res.code === 0) {
						this.payDeposteModel.show = false;
                        this.$bvModal.msgBoxOk("支付成功", {
                        	title: "温馨提示",
                        	buttonSize: "sm"
                        });
						this.getUserDepositBillInfoList();
					} else {
						if (res.message === '余额不足') {
							this.$refs.payModal.showModal();
						}
					}
				});
			},
			submitSalesPayment() {
				if (this.paymentTypeModel.selectedType === "fund") {
					api.webCurrentSalePayWithFund(this.paymentTypeModel).then(res => {
						if (res.code === 0) {
							this.paymentTypeModel.show = false;
							this.getUserDepositBillInfoList();
						} else {
							if (res.message === '余额不足') {
								this.$refs.payModal.showModal();
							}
						}
					});
				} else {
					this.$bvModal.msgBoxOk("暂不支持该支付方式", {
						title: "提示",
						buttonSize: "sm"
					});
				}
			},
			closeDeposit(depositBillRecordUuid){
				this.depositBillList.isTableBusy = true;
               api.closeDepositBillOrder({depositBillRecordUuid}).then(res=>{
				this.depositBillList.isTableBusy = false;
				 if(res.code==0){
					this.$bvModal.msgBoxOk("定单关闭成功", {
						title: '提示',
						buttonSize: 'sm'
					})
					this.getUserDepositBillInfoList();
				 }
			   })
			},
            onSginContract(row) {
				if(this.depositBillList.isTableBusy == true){
					return;
				}
                this.depositBillList.isTableBusy = true;
                api.AutoSignContract({
                    shoppingType: '预售',
                    orderUuid: row.item.depositBillRecordUuid
                }).then(res => {
                    this.depositBillList.isTableBusy = false;
                    if (res.code === 0) {
                        window.open(res.data.signResult, "_blank");
                    }
                });
            }
		}
	};
</script>

<style>
	.search-wrap {
		margin-top: 30px;
	}

	/* 选择下单日期 */
	.search-input .ivu-input {
		height: 32px;
		line-height: 32px;
		width: 200px;
		padding: 0px 7px;
		color: #333;
	}

	.search-input .ivu-input-prefix i,
	.ivu-input-suffix i {
		font-size: 22px;
		line-height: 32px;
		color: #808695;
	}


	.order-input {
		height: 32px;
		line-height: 32px;
		width: 220px;
		padding: 0px 7px;
		color: #333;
	}

	.order-button {
		height: 32px;
		line-height: 32px;
		width: 50px;
		padding: 0px;
	}

	.custom-control-input:checked~.custom-control-label::before {
		color: #fff !important;
		border-color: #28a745 !important;
		background-color: #28a745 !important;
	}

	.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
		background-color: #01B252 !important;
	}

    .delivery-list{margin-top: 20px;}
    .delivery-list th {
    	background-color: #efefef;
    	height: 40px;
    	line-height: 40px;
    }
    .delivery-list tr{text-align: center;background:#fafafa;}
    .delivery-list th{background:#fafafa;}
    .delivery-list td{font-size: 14px;}

    .table thead th {
    	vertical-align: bottom;
    	border-bottom: 2px solid #dbdbdb;
    }

	/* 表格 */
	.dataTable {
		margin-top: 20px;
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}

	/* 表格操作 */
	.table-sm td a {
		color: #00B151;
	}

	/* 页码 */
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}



	.radio-wrap .custom-control-label {
		padding-top: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/view/no-deposit-list/index.vue